export default "__VITE_ASSET__BzZrp0Lt__"